{
  "slug": "can-anxiety-lower-iq-scores",
  "title": "উদ্বেগ কি আইকিউ টেস্টের স্কোর কমাতে পারে?",
  "description": "উদ্বেগ মনোযোগ বা কর্ম স্মৃতি খাওয়াতে পারে, কিন্তু প্রভাব ভিন্ন হতে পারে।",
  "category": "IQ প্রশ্নের উত্তর",
  "sections": [
    {
      "heading": "সংক্ষিপ্ত উত্তর",
      "paragraphs": ["উদ্বেগ মনোযোগ বা কর্ম স্মৃতি খাওয়াতে পারে, কিন্তু প্রভাব ভিন্ন হতে পারে।"]
    },
    {
      "heading": "এটাকে কি প্রভাবিত করে",
      "paragraphs": [
        "পরীক্ষার মান, বয়স, স্বাস্থ্য, ভাষা, শিক্ষা, উৎসাহ, পরিবেশ এবং উদ্দেশ্য সবকিছুই গুরুত্বপূর্ণ।",
        "গড়ে একটি গবেষণার প্রভাব একজন ব্যক্তির সঠিক পূর্বাভাস দিতে পারে না।"
      ]
    },
    {
      "heading": "নির্দেশনা",
      "paragraphs": [
        "পর্যাপ্ত ঘুম, নিরাপদ পরিবেশ, আরামদায়ক পরিবেশ এবং উপযুক্ত যন্ত্র ব্যবহার করুন।",
        "শিশু, স্বাস্থ্য, অসুস্থতা, বা উচ্চ ঝুঁকিপূর্ণ সিদ্ধান্তের ক্ষেত্রে, একজন যোগ্য পেশাদারকে পরামর্শ দিন।"
      ]
    }
  ],
  "related": ["what-is-iq", "how-is-iq-measured", "can-iq-change-over-time"],
  "sources": [],
  "faqs": [],
  "summary": "উদ্বেগ মনোযোগ বা কর্মক্ষম স্মৃতিশক্তির উপর প্রভাব ফেলতে পারে, কিন্তু এর প্রভাব ভিন্ন ভিন্ন হতে পারে। 18 জুলাই 2026."
}
